import React from 'react'
import PropTypes from 'prop-types'
import { RegionBackground, RegionContent, RegionMain } from './index.style'
import ScrollSection from '../ScrollSection'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Spacer from '../Spacer'
import { Label, TextBody } from '../TextStyles'
import RichText from '../RichText'
import AnimateSplitText from '../animation/AnimateSplitText'
import AnimateScaleIn from '../animation/AnimateScaleIn'

const Region = ({
  id,
  dates,
  linkId,
  title,
  description,
  backgroundImage,
  labelColor,
  maxWidth,
}) => {
  const { image: inlineImage } = title.references[0].file.details
  const bgImage = getImage(backgroundImage)
  const aspectRatio = inlineImage.width / inlineImage.height

  return (
    <ScrollSection>
      <RegionMain id={linkId}>
        <RegionBackground>
          <AnimateScaleIn id={`${id}-img`}>
            <GatsbyImage image={bgImage} alt={backgroundImage.description} />
          </AnimateScaleIn>
        </RegionBackground>

        <Spacer size={[170, 340]} />

        <RegionContent aspectRatio={aspectRatio} maxWidth={maxWidth}>
          <Label bgColor={labelColor}>{dates}</Label>

          <Spacer size={[16, 32]} />

          <RichText id={id} content={title} />

          <Spacer size={[24, 60]} />

          <TextBody>
            <AnimateSplitText id={`${id}-description`}>
              {description}
            </AnimateSplitText>
          </TextBody>
        </RegionContent>

        <Spacer size={[170, 340]} />
      </RegionMain>
    </ScrollSection>
  )
}

Region.propTypes = {
  id: PropTypes.string,
  dates: PropTypes.string,
  title: PropTypes.object,
  description: PropTypes.string,
  backgroundImage: PropTypes.object,
  labelColor: PropTypes.string,
  maxWidth: PropTypes.number,
}

export default Region
